import { Breadcrumbs, Link, Typography, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import StructuredData from "./seo/StructuredData";
import { siteUrl } from "./seo/config";

type Crumb = { label: string; path: string };

type Props = {
  items: Crumb[];
};

const BreadcrumbsNav = ({ items }: Props) => {
  const theme = useTheme();
  const structured = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: `${siteUrl}${item.path}`,
    })),
  };

  const lastIndex = items.length - 1;

  return (
    <>
      <StructuredData data={structured} />
      <Breadcrumbs aria-label="breadcrumb" sx={{ my: 2, mx: theme.spacing(8) }}>
        {items.map((item, idx) =>
          idx === lastIndex ? (
            <Typography key={item.path} color="text.primary">
              {item.label}
            </Typography>
          ) : (
            <Link
              key={item.path}
              component={RouterLink}
              to={item.path}
              underline="hover"
              color="inherit"
            >
              {item.label}
            </Link>
          )
        )}
      </Breadcrumbs>
    </>
  );
};

export default BreadcrumbsNav;

